export default "__VITE_ASSET__Cuvgmmli__"